/* src/app/order/components/order-pricing/pricing-adjustments/pricing-adjustments.style.scss */
.pricing-adjustments {
  display: flex;
  flex-direction: column;
}
.pricing-adjustments .description {
  margin-bottom: 20px;
  align-self: stretch;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: normal;
}
.pricing-adjustments .intermediate-price-adjustments {
  margin-bottom: 18px;
}
.pricing-adjustments .intermediate-price-adjustments .intermediate-price-adjustment-label {
  margin-bottom: 8px;
}
.pricing-adjustments .intermediate-price-adjustments .intermediate-price-adjustment-values {
  display: flex;
  align-items: center;
}
.pricing-adjustments .intermediate-price-adjustments .intermediate-price-adjustment-values .chosen-value {
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-right: 20px;
  width: 130px;
  height: 40px;
  background: #f2f2f2;
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
}
.pricing-adjustments .intermediate-price-adjustments .intermediate-price-adjustment-values #adjustment-values > nb-radio {
  display: inline-block !important;
}
.label {
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: #007d40;
}
/*# sourceMappingURL=pricing-adjustments.style.css.map */
